import React from 'react'
import styled from 'styled-components'
import { Separator } from '../Separator/Separator'
import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'
import { Sanitizer } from 'live/services/sanitizer'

interface HeaderMiniCardProps {
    children?: React.ReactNode
    style?: React.CSSProperties
    title?: string
    titleInfo?: string
    content?: {
        text: string
        color?: string
        style?: React.CSSProperties
    }
    iconConfig?: {
        side?: 'left' | 'right'
        icon?: string
        color?: string
        style?: React.CSSProperties
    }
}

export const Tooltip = ({
    icon,
    text = '',
    color = 'var(--gray-500)'
}: {
    icon: string
    text: string
    color: string
}): JSX.Element => {
    return (
        <>
            {text && (
                <LiveTooltip className="" content={i18n(text)} position="top">
                    <i className={icon} style={{ marginLeft: 4, color }}>
                        {' '}
                    </i>
                </LiveTooltip>
            )}
        </>
    )
}
export const HeaderMiniCard = (props: HeaderMiniCardProps): JSX.Element => {
    const { children, style, title, titleInfo, content, iconConfig } = props

    const IElement = iconConfig?.icon ? (
        <i
            className={iconConfig.icon + ' title-large'}
            style={iconConfig?.style || { color: iconConfig?.color || 'var(--gray-600)' }}
        ></i>
    ) : (
        <i
            className="far fa-circle title-large"
            style={iconConfig?.style || { color: iconConfig?.color || 'var(--gray-600)' }}
        ></i>
    )

    return (
        <Container style={style || {}}>
            <Sanitizer html={title}>
                {sanitized => (
                    <div className="title">
                        <span
                            className="title"
                            dangerouslySetInnerHTML={{
                                __html: sanitized
                            }}
                        />
                        {titleInfo && <Tooltip icon={'far fa-info-circle'} text={titleInfo} color="gray-500" />}
                    </div>
                )}
            </Sanitizer>
            <Content>
                <div className="header">
                    {iconConfig?.side === 'left' && IElement}
                    <Sanitizer html={content?.text}>
                        {sanitized => (
                            <span
                                className="title-large"
                                dangerouslySetInnerHTML={{
                                    __html: sanitized
                                }}
                                style={content?.style || { color: content?.color || 'var(--gray-800)' }}
                            />
                        )}
                    </Sanitizer>

                    {!iconConfig?.side ? IElement : iconConfig?.side === 'right' && IElement}
                </div>

                {children && (
                    <Separator
                        orientation="horizontal"
                        width="100%"
                        color="var(--gray-300)"
                        style={{ margin: '8px 0' }}
                    />
                )}

                {children}
            </Content>
        </Container>
    )
}

const Container = styled.div`
    width: 326px;
    display: flex;
    flex-direction: column;
    flex: 1;
    .title {
        color: var(--gray-600);
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 4px;
    }
`
const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    background: #f9f9fa;
    border-radius: 3px;
    padding: 16px;
    border: 1px solid var(--gray-200);

    .header {
        display: flex;
        justify-content: space-between;
        i {
            color: var(--gray-600);
        }
    }

    .title-large {
        font-size: 28px;
        font-weight: 600;
        color: var(--gray-800);
        line-height: 36px;
    }
`
